export enum StatusOportunidadeOfertaTr {
  REPROVADO = 'Reprovado',
  APROVADO = 'Aprovado',
  // AGUARDANDO_PRICING = 'Aguardando Pricing',
  // AGUARDANDO_PARCEIRO = 'Aguardando Parceiro',
  // ERRO_COMERCIAL = 'Erro Comercial',
  // ERRO_PRINCING = 'Erro Pricing',
  // VALORES_ATUALIZADOS = 'Valores Atualizados',
  // P2 = 'P2',
  // PRE_PROPOSTA = 'Pré Proposta',
  // TARGET = 'Target',
  // REVISAO = 'Revisão',
  // OFERTA_DISPONIVEL_PARA_ENVIO = 'Oferta Disponível para Envio',
  // INFORMACOES_FALTANTES = 'Informações faltantes',
  EM_ANDAMENTO = 'Em Andamento',
  VENCIDO = 'Vencido',
  LIBERADO = 'Liberado',
}
